module.exports = __webpack_public_path__ + "static/soc3-34dd6cce17d2596c7dbf3fe9d436bef1.png";